/**
 * @deprecated
 */
export interface IClassSkill {
  id: number;
  typeId: number | null;
  name: string;
  assessment: string | null;
  displayOrder: number | null;
  active: boolean;
}

/**
 * @deprecated
 */
export class ClassSkill implements IClassSkill {
  id;
  typeId;
  name;
  assessment;
  displayOrder;
  active;

  constructor(config: IClassSkill) {
    this.id = config.id;
    this.typeId = config.typeId;
    this.name = config.name;
    this.assessment = config.assessment;
    this.displayOrder = config.displayOrder;
    this.active = config.active;
  }
}
